import React,{Component, useCallback,useState} from 'react'
import { Box, Button, Container, Grid, Link, TextField, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Diversity1, LensTwoTone } from '@mui/icons-material';
import FormControl from '@mui/material/FormControl';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { render } from '@testing-library/react';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import Paper from '@mui/material/Paper';
import queryString from "query-string"
import { Navigate } from "react-router-dom"
import validator from 'validator'
import DoneIcon from '@mui/icons-material/Done';
export default class Reset extends React.Component{
  email;
  constructor(){
    super()
    this.state={
      PassErrorMsg:'',
      modalOpen:false,
      style : {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1000,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
      },
      upperCase:true,
      lowerCase:true,
      number:true,
      symbol:true,
      length:true,
      email:'',
      newPassword:'',
      confirmPassword:'',
      status:'',
      loginPage:false,
      mail:""
    }
  }
  maskEmail=(email) =>{   
    const [localPart, domainPart] = email.split('@');
    
   
    const firstThreeChars = localPart.slice(0, 3);
    
    
    const maskedLocalPart = firstThreeChars + '*'.repeat(localPart.length - 3);
    
    
    return maskedLocalPart + '@' + domainPart;
}
  componentDidMount=()=>{
    const queryParams = queryString.parse(window.location.search)
    this.checkToken(queryParams.token)
    this.email=localStorage.getItem("EMAILID")
    this.partymail = JSON.parse(localStorage.getItem('party_mail'));
    
    if (localStorage.getItem('party_mail')) {

      const id = this.partymail.mail
      const maskedEmail = this.maskEmail(id);
      //console.log(maskedEmail);
      this.setState({email:maskedEmail})
      this.setState({mail:this.partymail.mail})
    }
  }
  onModelClick=()=>{
    this.setState({modalOpen:true})
  }
  onModelCose=()=>{
    this.setState({modalOpen:false,confirmPassword:'',newPassword:'',loginPage:true})
  }
  checkToken=(token)=>{
    fetch(`eadmin/v1/set/check_resetpass_token?token=${token}` ,{
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      },
      }).then((response) => response.json())
      .then((responseJson) => {
      if(responseJson.status ){
        this.setState({status:responseJson.status,})
      }else if(!responseJson.status){
        alert(responseJson.errorMsg)
      }else{
        alert('no record found')
      }
    }).catch((error) => {
      alert(error)
    });
  }
  upDatePassword=()=>{
    if(this.state.confirmPassword!==this.state.newPassword){
      alert('new Password and Confirm Password mismatched')
    }else{
      this.email=localStorage.getItem("EMAILID")
      if(!this.state.status){
        alert("Please Check the Mail Verify it")
      }else if(this.state.confirmPassword===''||this.state.newPassword===''){
        alert("Please Enter Password")
      }if(this.state.confirmPassword!==this.state.newPassword){
        alert("New password Mismatch to the Confirm Password")
      }else{
        let json_data={emailId:this.email,password:this.state.newPassword}
        fetch(`eadmin/v1/set/update_password`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body:(JSON.stringify(json_data)),
        }).then((response) => response.json())
        .then((responseJson) => {
        if(responseJson.status ){
      
          this.onModelClick()
          localStorage.removeItem("EMAILID");
          localStorage.removeItem("party_mail")
        } 
        else{
          alert(responseJson.errorMsg)
        }
        }).catch((error) => {
          alert(error)
        });
      }
    }
   
  }
  validateUpperCase=(value)=> {
    const regexp = /^[A-Z]/;
    const regexp2=/(?=.*[a-z])/;
    const regexp3=/(?=.*[0-9])/;
    const regexp4=/(?=.*[!@#$%^&*])/;
      if (regexp.test(value)){
        this.setState({upperCase:false})
      }
      if (regexp2.test(value)){
        this.setState({lowerCase:false})
      } 
      if (regexp3.test(value)){
        this.setState({number:false})
      } 
      if (regexp4.test(value)){
        this.setState({symbol:false})
      }
      if(value.length===8){
        this.setState({length:false})
      }
      if (validator.isStrongPassword(value, {
        minLength: 8, minLowercase: 1,
        minUppercase: 1, minNumbers: 1, minSymbols: 1
      }
      )) {
        this.setState({PassErrorMsg:'Is Strong Password',})
      } else {
        this.setState({PassErrorMsg:'Is Not Strong Password'})
      }
    }
  render(){
    return(
      <>
        <div>
          <title>Reset Password</title>
        </div>
        <Paper sx={{ p: 2, marginTop: '10%',marginLeft:'28%', maxWidth: '50%', flexGrow: 1 ,}}>
          <Box
            component="main"
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexGrow: 1,
              minHeight: '100%',
              marginTop:'8%'
            }}>
            <Container maxWidth="sm">
              <form>
                <Box sx={{ my: 3 }}>
                  <Typography color="textPrimary" variant="h4"> Reset Password</Typography>
                  <Typography
                    color="textSecondary"
                    gutterBottom
                    variant="body2">
                  </Typography>
                </Box>
              
                <TextField
                 error={this.state.PassErrorMsg=== "Is Not Strong Password"  }
                  fullWidth
                  label="New Password"
                  margin="normal"
                  variant="outlined"
                  type="password"
                  value={this.state.newPassword}
                  onChange={(evt) =>{this.validateUpperCase(evt.target.value)
                    this.setState({newPassword:evt.target.value})}}
                 // onChange={(evt)=>this.setState({newPassword:evt.target.value})}
                /><br/> 
                {this.state.PassErrorMsg === 'Is Not Strong Password' ? <span style={{
                fontWeight: 'bold',
                color: 'red',
              }}>
              {this.state.PassErrorMsg} </span> :
              <span style={{
                fontWeight: 'bold',
                color: 'green',
              }}>
              {this.state.PassErrorMsg} </span>}<br/>
                <Grid container >
                  <Grid item xs={12} sm={12} md={6}>
                  {this.state.length?
                    <span style={{color:'red'}}><DoneIcon  /> 8 character Minimum </span>:
                    <span style={{color:'green'}}><DoneIcon  />8 character Minimum</span>  }
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                  {this.state.number?
                    <span style={{color:'red'}}><DoneIcon  />one number </span>:
                    <span style={{color:'green'}}><DoneIcon  />one number</span>  }
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    {this.state.upperCase?
                    <span style={{color:'red'}}><DoneIcon  />one uppercase </span>:
                    <span style={{color:'green'}}><DoneIcon  />one uppercase</span>  }
                  </Grid>
                  <Grid item xs={12} sm={12}  md={6}>
                  {this.state.lowerCase?
                 <span style={{color:'red'}}><DoneIcon  />one lowercase </span>:
                 <span style={{color:'green'}}><DoneIcon  />one lowercase</span>  }
                    </Grid>
                   
                    <Grid item xs={12} sm={12} md={6}>
                    {this.state.symbol?
                   <span style={{color:'red'}}> <DoneIcon  />one symbol must</span>:
                   <span style={{color:'green'}}><DoneIcon />one symbol must</span>}
                    </Grid>
                </Grid>
                <TextField
                  fullWidth
                  label="Confirm Password"
                  margin="normal"
                  type="password"
                  variant="outlined"
                  value={this.state.confirmPassword}
                  onChange={(evt)=>this.setState({confirmPassword:evt.target.value})}
                />
                <Box sx={{ py: 2 }}>
                  <Button color="primary" fullWidth  size="large" variant="contained" onClick={this.upDatePassword}>Submit</Button>
                </Box>
                <Typography  color="textSecondary"  variant="body2"> Don&apos;t have an account? {' '}
                  <a  href='/register'  variant="subtitle2" underline="hover" sx={{cursor: 'pointer' }}>Sign Up</a>
                </Typography>
              </form>
            </Container>
          </Box>
        </Paper>
        <ModalTransition>
          {this.state.modalOpen && (
            <Modal onClose={this.onModelCose} >
              <ModalHeader>
                <ModalTitle>Reset Password</ModalTitle>
              </ModalHeader>
              <ModalBody>
                <label>Password Updated</label>
              </ModalBody>
              <ModalFooter>
                <Button appearance="primary" onClick={this.onModelCose} autoFocus>
                  OK
                </Button>
              </ModalFooter>
            </Modal>
          )}
        </ModalTransition>
        <ModalTransition>
          {this.state.model1 && (
            <Modal>
              <Box sx={ this.state.style}>
                <Grid container spacing={2}>
                  <Grid item xs={4} md={4}/>
                  <Grid item  style={{  width: '1150%',height:"100%" }} xs={12} md={4} sm={12}>
                    <Box  p={1} style={{width:'100%'}}>
                      <div className="greyBox" style={{width:'95%'}}>
                        <div className="row">
                          <div className="col-sm-11">
                            {/* <h5 style={{paddingLeft:'1%',margin:'auto'}} className="lato-font"> Reset Password</h5>*/}
                          </div>
                        </div>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item xs={4} md={4}/>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={4} md={3}/>
                  <Grid item xs={12} sm={12} md={6}>
                    <FormControl sx={{ m: 1, width: '85%' }}>
                      <TextField fullWidth  label="New Password" margin="normal"  type="password" variant="outlined"/>
                    </FormControl>
                    <Grid item xs={4} md={3}/>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={4} md={3}/>
                  <Grid item xs={12} sm={12} md={6}>
                    <FormControl sx={{ m: 1, width: '85%' }}>
                      <TextField  fullWidth label="Confirm Password"  margin="normal" type="password"  variant="outlined"/>
                    </FormControl>
                  </Grid> 
                  <Grid item xs={4} md={3}/>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={4} md={4}/>
                  <Grid item xs={12} sm={12} md={4}>
                    <div className="button">
                      <Button  variant="contained" style={{color:'white',width:'70%'}} >Save</Button>
                    </div>
                  </Grid>
                  <Grid item xs={4} md={4}/>
                </Grid><br/>
              </Box>
            </Modal>
          )}
        </ModalTransition>
        { 
          this.state.loginPage && <Navigate to='/login' replace={true}/>
        }
      </>
    )
  }
}

        
